
var headerNav = {
  init: function () {
    var s = this;
    var header = s.header = $('#headernav');
    var desktopnav = $('#desktopnav');
    var topnav = s.topnav = $('#topnav');
    var topnav_main = topnav.find('.main');
    var menu_btn = $('.menubtn');
    var close_btn = $('#topnav .closebtn');
    // var has_sub_li = header.find('.has_sub');
    // var lg_subnav_btn = header.find('.lg_subnav_btn');

    // if ($('html').is('.wp')) {
    //   header.find('.wpml-ls>ul').attr('id', 'langnav');
    // }
    

    menu_btn.click(function () {
      if (body_el.hasClass('nav-open')) s.closeNav();
      else s.openNav(topnav_main);
    });

    close_btn.click(function () {
      s.closeNav();
    });

    topnav.find('.bg').click(function () {
      s.closeNav();
    });

    
    $('#nav_overlayer').click(s.closeAll);

    var resize = function () {
      if (desktopnav.css('visibility') != 'hidden' && body_el.is('.nav-open')) {
        s.closeNav();
      }
    }

    $(window).on('resize.topnav', resize);

    // s.active();
    // s.responsive();
    // s.scrollHide();
    s.maxHeader();
    s.toTop();

    // if ( !$('html').is('.wp') ) s.lang();

    if ( $('.cover-head').length ) {
      body_el.addClass('cover-header');
    }

    // if ($('html').is('.wp')) {
    //   $('#langnav script').remove();
    //   $('.trp-ls-shortcode-current-language').remove();
    //   $('.trp-ls-shortcode-language').removeAttr('style');
    // }
  },


  openNav: function (el) {
    var s = this;
    // this.closeAll();
    s.header.find('.has_sub.open').removeClass('open');
    body_el.addClass('nav-open');
    el.addClass('open');
  },

  closeNav: function () {
    var s = this;

    var open_el = s.topnav.find('.open').first();

    s.header.find('.open').removeClass('open');
    s.header.find('.sub-open').removeClass('sub-open');

    if (s.topnav.css('visibility') == 'hidden') {
      body_el.removeClass('nav-open subnav-open');
    } else {
      open_el.one(tt_transition_end, function () {
        body_el.removeClass('nav-open subnav-open');
      });
    }

  },

  closeAll: function () {
    var s = this;
    s.closeNav();
  },

  maxHeader: function () {
    var scrollEvent = function () {
      // var window_h = $(window).height();
      // var mscroll_el = $('.mscroll');
      var cover_head = $('.cover-head');
      var main_header = $('main header');
      var top = tt_root_scroll_wrap.scrollTop();
      var endv = 120;

      if ( cover_head.length ) endv = cover_head.innerHeight() - 40;
      if ( main_header.length ) endv = main_header.innerHeight() - 40;
      
      if (top < endv) body_el.addClass('max-header');
      else body_el.removeClass('max-header');
    }

    tt_root_scroll_wrap.on('scroll.minihead', scrollEvent);
    $(window).on('resize.minihead', scrollEvent);
    scrollEvent();
  },

  toTop: function () {
    var totop_btn = $('.totopbtn');

    totop_btn.click(function () {
      $(document).scrollTop(0);
      // $(document).scrollTo(0, 600);
    });
  }

}
